//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import SetElement from '@app/Cart/Variants/SetElement.vue'

export default {
  name: 'ProductSimpleSetView',
  components: {
    SetElement,
  },
  props: {
    product: {
      default: () => { },
    },
    price: {
      default: '0.00',
    },
    isSale: {
      default: () => false,
    },
    load: {},
    disabled: {
      default: () => false,
    },
    canRemove: {
      default: () => false,
    },
  },
  data() {
    return {
      currency: window.currency,
    }
  },
  computed: {
    baseElement() {
      return this.product.element.props
    },
    setElement() {
      return this.product.element.props.set.props
    },
    minimalQuantity() {
      // products without inventory tracking do not limit the set quantity
      const limit = ({ track_inventory: trackInventory, stock_quantity: stock }) => (trackInventory ? stock : Infinity)
      const quantity = Math.min(limit(this.baseElement.product.props), limit(this.setElement.product.props))
      return Number.isFinite(quantity) ? quantity : 999999999
    },
    canChange() {
      // fix me
      return !this.disabled || !this.canRemove || !this.isSale
    },
  },
}
